import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["exact", "experimental_matchSearchExact", "onClick", "to"];
import { isValidElement, Children } from 'react';
import { matchPath, useLocation } from 'quartz-routing/react-router';
import { SideNavItem } from 'foundations-components/transitional/components/SideNav';
import useIsActive from './internal/useIsActive';
import useRouterProps from './useRouterProps';
import { jsx as _jsx } from "react/jsx-runtime";
const RouterSideNavLeaf = props => {
  const {
      exact = false,
      experimental_matchSearchExact,
      onClick,
      to
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const {
    onClick: handleOnClick,
    href
  } = useRouterProps({
    onClick,
    to: to || ''
  });
  const active = useIsActive(to || '', exact, experimental_matchSearchExact);
  return /*#__PURE__*/_jsx(SideNavItem, Object.assign({}, rest, {
    onClick: handleOnClick,
    href: href,
    active: active,
    role: "link"
  }));
};
const RouterSideNavNode = props => {
  const location = useLocation();
  const {
    children
  } = props;
  let hasActiveChild = false;
  Children.forEach(children, element => {
    if (!hasActiveChild && /*#__PURE__*/isValidElement(element)) {
      const {
        to,
        exact = false,
        strict = false
      } = element.props;
      const path = typeof to === 'object' ? to.pathname : to;
      hasActiveChild = Boolean(matchPath(location.pathname, {
        path,
        exact,
        strict
      }));
    }
  });
  const defaultOpen = props.defaultOpen == null ? hasActiveChild : props.defaultOpen;
  return /*#__PURE__*/_jsx(SideNavItem, Object.assign({
    defaultOpen: defaultOpen
  }, props));
};
const RouterSideNavItem = props => {
  const {
    to,
    children
  } = props;
  if (to == null && children) {
    return /*#__PURE__*/_jsx(RouterSideNavNode, Object.assign({}, props));
  }
  return /*#__PURE__*/_jsx(RouterSideNavLeaf, Object.assign({}, props));
};
export default RouterSideNavItem;